import { Alert, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useState } from 'react';
import { IConfig } from '../../../Interfaces/IConfig';
import { DsgvoDialog } from './DsgvoDialog';

export type IDataPrivacyAlertProps = {
  configObject: IConfig;
  isTermsAndConditionsChecked: boolean;
  setIsTermsAndConditionsChecked: (checked: boolean) => void;
};

export function DataPrivacyAlert({
  configObject,
  isTermsAndConditionsChecked,
  setIsTermsAndConditionsChecked,
}: IDataPrivacyAlertProps) {
  const [isDsgvoOpen, setIsDsgvoOpen] = useState(false);

  return (
    <>
      <DsgvoDialog
        configObject={configObject}
        open={isDsgvoOpen}
        handleClose={() => setIsDsgvoOpen(false)}
      />

      <Alert severity='info' icon={false}>
        <FormControlLabel
          label={
            <Typography component='span'>
              Ich bin mit der Verarbeitung meiner Daten zur Interaktion und zum
              Datenaustausch mit dem Mandantenportal einverstanden. Die&nbsp;
              <Typography
                component='span'
                onClick={event => {
                  event.stopPropagation(); // Verhindert die Checkbox-Aktivierung
                  setIsDsgvoOpen(true);
                }}
                sx={{
                  color: 'blue',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
              >
                Datenschutzerklärung
              </Typography>
              &nbsp; habe ich zur Kenntnis genommen.
            </Typography>
          }
          control={
            <Checkbox
              checked={isTermsAndConditionsChecked}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setIsTermsAndConditionsChecked(event.target.checked)
              }
              inputProps={{ 'aria-label': 'controlled' }}
              required
            />
          }
        />
      </Alert>
    </>
  );
}
